/* eslint-disable import/no-default-export */
import { Action, actionCreator, createReducer } from '@trello/redux';

const SET_HEADER_BRANDING_COLOR = Symbol('ui/SET_HEADER_BRANDING_COLOR');
const REMOVE_HEADER_BRANDING_COLOR = Symbol('ui/REMOVE_HEADER_BRANDING_COLOR');
const SET_HEADER_BRANDING_LOGO = Symbol('ui/SET_HEADER_BRANDING_LOGO');
const REMOVE_HEADER_BRANDING_LOGO = Symbol('ui/REMOVE_HEADER_BRANDING_LOGO');
const SET_HEADER_BRANDING_NAME = Symbol('ui/SET_HEADER_BRANDING_NAME');
const REMOVE_HEADER_BRANDING_NAME = Symbol('ui/REMOVE_HEADER_BRANDING_NAME');

type SetHeaderBrandingColorAction = Action<
  typeof SET_HEADER_BRANDING_COLOR,
  string
>;
type RemoveHeaderBrandingColorAction = Action<
  typeof REMOVE_HEADER_BRANDING_COLOR,
  null
>;
type SetHeaderBrandingLogoAction = Action<
  typeof SET_HEADER_BRANDING_LOGO,
  string
>;
type RemoveHeaderBrandingLogoAction = Action<
  typeof REMOVE_HEADER_BRANDING_LOGO,
  null
>;

type SetHeaderBrandingNameAction = Action<
  typeof SET_HEADER_BRANDING_NAME,
  string
>;
type RemoveHeaderBrandingNameAction = Action<
  typeof REMOVE_HEADER_BRANDING_NAME,
  null
>;

export interface HeaderState {
  brandingColor: string | undefined;
  brandingLogo: string | undefined;
  brandingName: string | undefined;
}

const initialState: HeaderState = {
  brandingColor: undefined,
  brandingLogo: undefined,
  brandingName: undefined,
};

export default createReducer(initialState, {
  [SET_HEADER_BRANDING_COLOR](
    state: HeaderState,
    { payload: brandingColor }: SetHeaderBrandingColorAction,
  ) {
    return {
      ...state,
      brandingColor,
    };
  },
  [REMOVE_HEADER_BRANDING_COLOR](state: HeaderState) {
    return {
      ...state,
      brandingColor: undefined,
    };
  },
  [SET_HEADER_BRANDING_LOGO](
    state: HeaderState,
    { payload: brandingLogo }: SetHeaderBrandingLogoAction,
  ) {
    return {
      ...state,
      brandingLogo,
    };
  },
  [REMOVE_HEADER_BRANDING_LOGO](state: HeaderState) {
    return {
      ...state,
      brandingLogo: undefined,
    };
  },
  [SET_HEADER_BRANDING_NAME](
    state: HeaderState,
    { payload: brandingName }: SetHeaderBrandingNameAction,
  ) {
    return {
      ...state,
      brandingName,
    };
  },
  [REMOVE_HEADER_BRANDING_NAME](state: HeaderState) {
    return {
      ...state,
      brandingName: undefined,
    };
  },
});

export const setHeaderBrandingColor = actionCreator<SetHeaderBrandingColorAction>(
  SET_HEADER_BRANDING_COLOR,
);
export const removeHeaderBrandingColor = actionCreator<RemoveHeaderBrandingColorAction>(
  REMOVE_HEADER_BRANDING_COLOR,
);
export const setHeaderBrandingLogo = actionCreator<SetHeaderBrandingLogoAction>(
  SET_HEADER_BRANDING_LOGO,
);
export const removeHeaderBrandingLogo = actionCreator<RemoveHeaderBrandingLogoAction>(
  REMOVE_HEADER_BRANDING_LOGO,
);
export const setHeaderBrandingName = actionCreator<SetHeaderBrandingNameAction>(
  SET_HEADER_BRANDING_NAME,
);
export const removeHeaderBrandingName = actionCreator<RemoveHeaderBrandingNameAction>(
  REMOVE_HEADER_BRANDING_NAME,
);
